// assets/frontend/src/js/search-interactions.js
// ───────────────────────────────────────
// Mejoras de UX para la búsqueda pública (/buscar):
// - Envío desde el buscador del header sin doble submit
// - Focus management en el buscador de la página de resultados
// - Envío automático al cambiar un filtro del sidebar

import '../styles/search.scss';

function initSearchInteractions() {
  // ── Buscadores del header / hero: prevenir doble submit ──
  document.querySelectorAll('.header-search, .hero-search').forEach((form) => {
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    let submitting = false;
    form.addEventListener('submit', (e) => {
      if (submitting) {
        e.preventDefault();
        return;
      }
      submitting = true;
      window.setTimeout(() => {
        submitting = false;
      }, 500);
    });

    // Seleccionar el texto al enfocar para reescribir rápido.
    input.addEventListener('focus', () => input.select());
  });

  // ── Página de resultados: mantener foco en el buscador ──
  const searchInput = document.getElementById('search-input');
  if (searchInput) {
    searchInput.focus();
    searchInput.select();
  }

  // ── Filtros del sidebar: envío automático al cambiar ──
  document.querySelectorAll('[data-search-filter]').forEach((select) => {
    select.addEventListener('change', () => {
      select.closest('form')?.submit();
    });
  });
}

document.addEventListener('DOMContentLoaded', initSearchInteractions);

export { initSearchInteractions };
